<div dropdown (onShown)="onShown()" placement="bottom left" container="body">
  <a
    (click)="onPushRates()"
    matTooltip="Push Rates & Availability to all connected API channels"
    matTooltipPosition="below"
    matTooltipClass="text-center"
    *ngIf="!(1 | isReadonlyRole)"
  >
    <i class="fal fa-house-signal"></i>
  </a>
  <a
    dropdownToggle
    matTooltip="View a chronological list of events that updates in real time."
    matTooltipPosition="below"
    matTooltipClass="text-center"
  >
    <i class="fal fa-bell"></i>
    <sup [hidden]="!unreadCount" class="badge">{{ unreadCount }}</sup>
  </a>
  <div *dropdownMenu class="notification-dropdown-box">
    <ul class="nav nav-tabs" (click)="$event.stopPropagation()">
      <li *ngFor="let tab of tabs" class="nav-item" (click)="onTabClick(tab)">
        <a class="nav-link" [ngClass]="{ active: activeTab === tab }">
          <i [class]="tab.icon"></i>
          {{ tab.title }} ({{ tab.amount }})
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div class="tab-pane fade show active">
        <ul class="icon-ul">
          <li *ngFor="let item of notifications" [class]="theme[item.type]?.class">
            <a (click)="onOpen(item)" class="notification-link" [class.details]="theme[item.type]?.details">
              <div class="li-icon-holder">
                <i [class]="theme[item.type]?.icon"></i>
              </div>
              <div class="li-content" [innerHTML]="getTitleHtml(item)"></div>
              <div class="li-content-right">
                <span class="time">{{ item.date | timeAgo }}</span>
              </div>
            </a>
          </li>
          <li class="all-notifications">
            <a routerLink="/dashboard" fragment="feed"> See all alerts </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
